var map = {
	"./location_archived.png": 2604,
	"./location_electrical.png": 8612,
	"./location_finishing.png": 2706,
	"./location_general.png": 4511,
	"./location_other.png": 2148,
	"./location_plumbingandcentralheating.png": 7366,
	"./location_telecom.png": 9534,
	"./location_unassigned.png": 3419,
	"./location_ventilationandaircon.png": 1330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 898;